export default "__VITE_ASSET__abe4f7ea__"